"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeterReadingSummaryCard = void 0;
var date_fns_1 = require("date-fns");
var react_1 = __importStar(require("react"));
var core_1 = require("../../../../shared/core");
var typography_1 = require("../../../../shared/core/utils/typography");
var copy_1 = require("../../copy");
var utils_1 = require("../MeterReadingsData/utils");
var PreviousMeterReading_1 = require("../PreviousMeterReading");
var CallToActionSection_1 = require("./CallToActionSection");
var get_ctas_1 = require("./get-ctas");
function readingDate(readingDateTime) {
    return (0, date_fns_1.format)(readingDateTime, 'd MMM');
}
function SummaryData(_a) {
    var msn = _a.msn, mpxn = _a.mpxn, fuelType = _a.fuelType, latestActualReading = _a.latestActualReading, isSmart = _a.isSmart, isNonComms = _a.isNonComms, meterNumOfDigits = _a.meterNumOfDigits, noOfFuelSupplies = _a.noOfFuelSupplies;
    var _b = (0, core_1.useComponents)(), SummaryList = _b.SummaryList, SummaryItem = _b.SummaryItem, Pii = _b.Pii;
    var showLastReading = !isSmart || isNonComms;
    var copy = (0, core_1.useCopy)(copy_1.defaultOptions).copy;
    return (react_1.default.createElement(SummaryList, null,
        msn && (react_1.default.createElement(SummaryItem, { label: copy('summaryMeterSerial'), "data-testid": "meter-reading-summary-card-msn" },
            react_1.default.createElement(Pii, null, msn))),
        noOfFuelSupplies > 1 && (react_1.default.createElement(SummaryItem, { label: fuelType === 'gas'
                ? copy('summarySupplyPointSerialGas')
                : copy('summarySupplyPointSerialElec'), "data-testid": "meter-reading-summary-card-mpxn" },
            react_1.default.createElement(Pii, null, mpxn))),
        showLastReading && latestActualReading ? (react_1.default.createElement(SummaryItem, { label: copy('summaryLastRead', {
                readDate: readingDate(latestActualReading.readingDateTime),
            }) }, latestActualReading && (react_1.default.createElement("div", { "data-testid": "meter-reading-summary-card-last-reading" },
            react_1.default.createElement(PreviousMeterReading_1.PreviousMeterReading, { fuel: fuelType, reading: latestActualReading, meterNumOfDigits: meterNumOfDigits }))))) : null));
}
function SmartMeterMessage(_a) {
    var fuelType = _a.fuelType, isNonComms = _a.isNonComms;
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    var _b = (0, core_1.useComponents)(), WarningNotification = _b.WarningNotification, SuccessNotification = _b.SuccessNotification;
    return isNonComms ? (react_1.default.createElement(WarningNotification, { id: "meter-reading-summary-card_non-comms-msg", "data-testid": "meter-reading-summary-card_non-comms-msg" },
        react_1.default.createElement(Copy, { copyKey: "summaryNonCommMessage", values: { fuelType: fuelType } }))) : (react_1.default.createElement(SuccessNotification, { id: "meter-reading-summary-card_comms-msg", "data-testid": "meter-reading-summary-card_comms-msg" },
        react_1.default.createElement(Copy, { copyKey: "summaryCommMessage", values: { fuelType: fuelType } })));
}
function MeterReadingSummaryCard(_a) {
    var isOnboarding = _a.isOnboarding, isInOMRWindow = _a.isInOMRWindow, fuelType = _a.fuelType, msn = _a.msn, mpxn = _a.mpxn, readings = _a.readings, isSmart = _a.isSmart, isNonComms = _a.isNonComms, meterNumOfDigits = _a.meterNumOfDigits, supplyIndex = _a.supplyIndex, noOfFuelSupplies = _a.noOfFuelSupplies;
    var _b = (0, core_1.useComponents)(), SummaryCard = _b.SummaryCard, Notification = _b.Notification;
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    var Footer = function () {
        var CTAs = (0, get_ctas_1.getCTAs)({
            isSmart: isSmart,
            isNonComms: isNonComms,
            hasRecentManualReading: !!latestActualReading,
            isOnboarding: isOnboarding,
            isInOMRWindow: isInOMRWindow,
        });
        return (react_1.default.createElement(CallToActionSection_1.CallToActionSection, { actions: CTAs, fuelType: fuelType, isSmart: isSmart, supplyIndex: supplyIndex }));
    };
    var latestActualReading = (0, react_1.useMemo)(function () {
        return (0, utils_1.getLatestManualReading)(readings);
    }, [readings]);
    return (react_1.default.createElement(core_1.Feature, { feature: "omrWithoutMsn" }, function (enabled) {
        return enabled ? (
        // if no MSN, use the footer cta in the body to fix spacing
        react_1.default.createElement(SummaryCard, { heading: (0, typography_1.capitalise)(fuelType), "data-testid": "meter-reading-summary-card__".concat(fuelType), icon: fuelType, footer: msn ? react_1.default.createElement(Footer, null) : null },
            msn ? (react_1.default.createElement(SummaryData, { msn: msn, mpxn: mpxn, noOfFuelSupplies: noOfFuelSupplies, fuelType: fuelType, latestActualReading: latestActualReading, isSmart: isSmart, isNonComms: isNonComms, meterNumOfDigits: meterNumOfDigits })) : !mpxn ? (react_1.default.createElement(Notification, { "data-testid": "no-msn-notification", id: "no-msn" },
                react_1.default.createElement(Copy, { copyKey: "noMsn" }))) : (react_1.default.createElement(Footer, null)),
            isSmart && !isOnboarding && (react_1.default.createElement(SmartMeterMessage, { fuelType: fuelType, isNonComms: isNonComms })))) : (react_1.default.createElement(SummaryCard, { heading: (0, typography_1.capitalise)(fuelType), "data-testid": "meter-reading-summary-card__".concat(fuelType), icon: fuelType, footer: msn && react_1.default.createElement(Footer, null) },
            //renders notification if msn is not available
            !msn ? (react_1.default.createElement(Notification, { "data-testid": "no-msn-notification", id: "no-msn" },
                react_1.default.createElement(Copy, { copyKey: "noMsn" }))) : (react_1.default.createElement(SummaryData, { msn: msn, mpxn: mpxn, noOfFuelSupplies: noOfFuelSupplies, fuelType: fuelType, latestActualReading: latestActualReading, isSmart: isSmart, isNonComms: isNonComms, meterNumOfDigits: meterNumOfDigits })),
            isSmart && !isOnboarding && (react_1.default.createElement(SmartMeterMessage, { fuelType: fuelType, isNonComms: isNonComms }))));
    }));
}
exports.MeterReadingSummaryCard = MeterReadingSummaryCard;
